/**
 * ============================================
 * BIGTIME VEREDELUNG FRONTEND v3.9.8
 * ============================================
 *
 * MODULARE STRUKTUR:
 * - Modul 1: Hauptmodul (Basis) - IMMER aktiv
 * - Modul 2: Veredelungsmodul - OPTIONAL
 * - Modul 3: Staffelpreismodul - OPTIONAL
 *
 * SZENARIEN:
 * 1. Nur Hauptmodul (teambestellung=ja)
 * 2. Mit Veredelung (veredelungsgruppe gesetzt)
 * 3. Mit Staffelpreisen (staffelpreise_aktiv=ja)
 * 4. Alles kombiniert
 *
 * CHANGELOG:
 * [29.09.2026] Property-Struktur ueberarbeitet (Thomas-Auftrag, R32 nicht relevant/nur lokal):
 *        - buildBaseProperties() liefert jetzt gruppierte + getrennte Properties: ALLGEMEIN,
 *          VEREDELUNGSOPTIONEN, DATEIEN (alle kundensichtbar) und TECHNISCH (INTERN) /
 *          DRUCKDATEI-REFERENZ (beide mit "_"-Prefix, kundenunsichtbar)
 *        - _Veredelungsgruppe -> Veredelungsgruppe (kein "_" mehr, jetzt kundensichtbar)
 *        - _Veredelung für -> Veredelung für (Veredelungs-Positions-Builder, kundensichtbar)
 *        - Checkbox/Checkbox-Text-Optionen (inkl. individueller Texte pro Artikel aus Modus 1)
 *          heissen jetzt "Veredelung [opt.beschreibung]" statt nur "[opt.beschreibung]"
 *        - server.js (CSV-Export) musste dafuer an 3 Stellen mitangepasst werden (exakte
 *          String-Matches auf die neuen Namen + neuer Filter fuer die Trenner-Properties),
 *          sonst waere die Bestell-CSV kaputt gegangen (doppelte/leere Veredelungsgruppe-Spalte,
 *          "Veredelung für" + Trenner als Muell-Spalten)
 * v3.9.8 - FIX: Cart-Drawer-Einschub oeffnet sich jetzt nach Add-to-Cart (Thomas-Meldung 31.08.2026)
 *        - Vorher: Nach Klick auf "In den Einkaufswagen legen" hart codierter Redirect auf
 *          /cart, IMMER - unabhaengig vom Theme-Warenkorbstil (Einschub/Seite). Grund: Die App
 *          fuegt Artikel per eigenem fetch('/cart/add.js') hinzu, nicht ueber das native
 *          Theme-Formular - der Theme-Code der normalerweise den Einschub oeffnet
 *          (ProductForm.onSubmitHandler in theme.js, this.cartDrawer?.show(...)) wird dabei
 *          nie durchlaufen.
 *        - Live-verifiziert (01.09.2026, per theme-sync/Admin-API direkt aus dem Live-Theme
 *          "Concept" gelesen, nicht nur aus dem Repo-Export): cart.js definiert <cart-drawer>
 *          mit eingebautem Listener auf das Custom Event 'cart:refresh' - bei
 *          detail.open===true laedt es den Mini-Cart-Sectioninhalt frisch nach (Section
 *          Rendering API) und oeffnet danach den Einschub. Genau dieses Event nutzt das
 *          Theme selbst bereits (nur mit open:false) im Fehlerfall von ProductForm.
 *        - Fix: Bei Erfolg wird jetzt 'cart:refresh' mit detail:{open:true} gefeuert statt
 *          window.location.href='/cart' - nutzt den vom Theme selbst bereitgestellten Hook,
 *          keine eigene Drawer-Logik nachgebaut.
 *        - Ausnahme: Ist der Theme-Warenkorbstil auf "Seite" gestellt (theme.settings.cartType
 *          === 'page', dasselbe Flag das ProductForm.onSubmitHandler selbst prueft) oder die
 *          App laeuft auf der Cart-Seite selbst, bleibt der Redirect auf /cart bestehen -
 *          dort gibt es kein <cart-drawer>-Element, das Event liefe ins Leere.
 * v3.9.7 - FIX: CDR (CorelDRAW) Datei-Upload wieder erlaubt (ALLOWED_EXTENSIONS + ALLOWED_ACCEPT)
 *        - Thomas hatte .cdr am 10.08.2026 manuell im Shopify Theme-Code-Editor ergaenzt,
 *          diese Aenderung war NIE im Git-Repo committed
 *        - Root Cause: Als v3.9.6 (Geschlecht-Feature) am 31.08.2026 live eingespielt wurde,
 *          wurde die gesamte Datei aus dem Repo-Stand ueberschrieben – ohne den nie
 *          committeten CDR-Zusatz. .cdr war seitdem live wieder blockiert (Client-seitige
 *          Pruefung in isFileAllowed(), VOR jedem Request an das Backend)
 *        - Server.js (Railway-Backend) hatte .cdr durchgehend korrekt in der Whitelist –
 *          das Backend war zu keinem Zeitpunkt betroffen
 * v3.9.6 - NEU: Dritte Auswahl-Dimension "Geschlecht" (nur sofern am Produkt vorhanden)
 *        - Farbe + Geschlecht filtern jetzt gemeinsam die angezeigten Größen
 *        - Bisher wurden bei Produkten mit Farbe+Geschlecht+Größe ALLE Größen
 *          über alle Geschlechter hinweg angezeigt (Geschlecht wurde ignoriert)
 *        - Reine Auswahl-/Anzeige-Änderung: Bestellung, Preisberechnung,
 *          Staffelpreise und Datei-Upload unveraendert
 * v3.9.5 - FIX: Mobile zeigt jetzt Preis-Spalte (nur "Verfügbar" ausgeblendet)
 *        - NEU: UVP dynamisch pro Variante (Einzelbestellung: gewählte Größe, Teambestellung: erste Variante)
 *        - NEU: Staffelpreis in Teambestellung-Tabelle angezeigt
 *        - UVP Fallback: compare_at_price > 0, sonst price
 * v3.9.4 - NEU: Verschlüsselte Varianten-ID für sichere Staffelpreis-Berechnung
 *        - Ruft /api/encrypt-variant auf beim Add-to-Cart
 *        - Speichert _enc Property statt _staffelpreis_originalpreis
 *        - Kein basispreis_staffelpreise Metafeld mehr nötig
 * v3.9.3 - PERF: Zurück zu parallelem Loading (schneller als Chunked)
 *        - FIX: Browser Vor/Zurück jetzt zuverlässig (ohne persisted check)
 *        - sessionStorage Cache bleibt für schnelles Nachladen
 * v3.9.2 - FIX: Browser-Zurück/Vorwärts zeigt jetzt korrekte Varianten
 *        - PERF: Chunked Loading (5 Requests gleichzeitig)
 *        - PERF: sessionStorage Cache (überlebt Browser-Navigation)
 *        - pageshow Event Handler für Browser-Navigation
 * v3.9.1 - FIX: Section Rendering API jetzt funktional
 *        - Parallele Requests für jede Größe (Farbe+Größe Kombination)
 *        - Korrekte Extraktion von Variant-ID, Preis und Verfügbarkeit
 *        - Caching der nachgeladenen Varianten
 *        - Getestet mit Concept Theme (RoarTheme)
 * v3.9.0 - NEU: Section Rendering API für 2000+ Varianten Support
 *        - Varianten werden dynamisch bei Farbwechsel nachgeladen
 *        - Kein 250-Varianten-Limit mehr
 *        - Kompatibel mit Concept Theme (RoarTheme)
 * v3.8.1 - FIX: Warenkorb-Items werden jetzt korrekt zusammengefasst
 *        - Identische Varianten mit gleichen Properties = 1 Line Item
 *        - Druckdateien-Properties bei allen Items gleich
 * v3.8.0 - Komplettes Refactoring, modulare Struktur
 *        - Fix: Nur Staffelpreise funktioniert jetzt
 *        - Neues Szenario: Nur Hauptmodul
 * v3.7.2 - Grundpreis-Berechnung korrigiert
 * v3.7.1 - Erste verfügbare Größe vorausgewählt
 * v3.7.0 - Staffelpreis-Tabelle mit Spaltenüberschriften
 * ============================================
 */

(function() {
  'use strict';

  // ============================================
  // KONFIGURATION & KONSTANTEN
  // ============================================
  
  const UPLOAD_API_URL = 'https://bigtime-veredelung-app-production.up.railway.app/api/upload';
  const ENCRYPT_API_URL = 'https://bigtime-veredelung-app-production.up.railway.app/api/encrypt-variant';
  
  const SIZE_ORDER = [
  // Kurzgrößen (Hosen)
  '24', '25', '26', '27', '28', '29', '30',
  // Normalgrößen
  '5XS', '4XS', '3XS', 'XXS', '2XS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', 'XXXL', '4XL', '5XL', '6XL',
  // Langgrößen + Kindergrößen (kollisionsfrei verschränkt)
  '94', '98', '104', '102', '106', '110', '116', '122', '128', '134', '140', '146', '152', '158', '164', '170', '176',
  ];

  const ALLOWED_EXTENSIONS = ['cdr','jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'tiff', 'tif', 'pdf', 'ai', 'eps', 'csv', 'xls', 'xlsx'];
  const ALLOWED_ACCEPT = '.cdr, .jpg,.jpeg,.png,.gif,.webp,.svg,.tiff,.tif,.pdf,.ai,.eps,.csv,.xls,.xlsx';

  // ============================================
  // APP STATE
  // ============================================
  
  let appData = {
    // Modul-Status
    gruppe: null,
    staffelpreiseAktiv: false,
    
    // Produkt-Daten
    variants: [],
    filteredVariants: [],
    productHandle: null,
    
    // NEU: Section Rendering API Daten
    sectionId: null,
    variantsLoading: false,
    variantsCache: {}, // Cache für nachgeladene Varianten pro Farbe
    
    // Farben & Größen
    selectedColor: null,
    availableColors: [],
    hasColors: false,
    colorOptionIndex: null,
    sizeOptionIndex: null,

    // Geschlecht (v3.9.6 NEU) - nur gesetzt, wenn das Produkt eine Geschlecht-Option hat
    selectedGender: null,
    availableGenders: [],
    hasGender: false,
    genderOptionIndex: null,

    // Bestellmodus
    mode: 'single',
    selectedSize: null,
    singleQuantity: 1,
    teamQuantities: {},
    
    // Veredelung (Modul 2)
    checkedOptions: {},
    textFieldValues: {},
    uploadedFiles: {},
    uploadComments: {},
    sessionId: null,
    folderConsoleUrl: null,
    
    // Staffelpreise (Modul 3)
    staffeln: [],
    einheit: 'Stück',
    uvp: null,
    hatGrundpreis: false,
    quantityValue: 1,
    referenceValue: 1
  };

  // ============================================
  // HILFSFUNKTIONEN
  // ============================================
  
  function getSizeIndex(size) {
    const upperSize = String(size).toUpperCase();
    const index = SIZE_ORDER.findIndex(s => s.toUpperCase() === upperSize);
    return index === -1 ? 999 : index;
  }

  function formatPrice(priceInCents) {
    const euros = parseFloat(priceInCents) / 100;
    return euros.toFixed(2).replace('.', ',') + ' €';
  }

  function formatPriceEuro(euros) {
    return parseFloat(euros).toFixed(2).replace('.', ',') + ' €';
  }

  function formatFileSize(bytes) {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

  function isFileAllowed(filename) {
    const ext = filename.split('.').pop().toLowerCase();
    return ALLOWED_EXTENSIONS.includes(ext);
  }

  // ============================================
  // v3.9.4 NEU: VARIANTEN-ID VERSCHLÜSSELUNG
  // ============================================
  
  /**
   * Verschlüsselt eine Varianten-ID über das Backend
   * @param {string|number} variantId - Die Shopify Varianten-ID
   * @returns {Promise<string|null>} - Der verschlüsselte String oder null bei Fehler
   */
  async function encryptVariantId(variantId) {
    try {
      const response = await fetch(ENCRYPT_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ variantId: String(variantId) })
      });
      
      if (!response.ok) {
        console.error('❌ Bigtime: Verschlüsselung fehlgeschlagen:', response.status);
        return null;
      }
      
      const data = await response.json();
      
      if (data.success && data.enc) {
        return data.enc;
      }
      
      return null;
    } catch (error) {
      console.error('❌ Bigtime: Verschlüsselungs-Fehler:', error);
      return null;
    }
  }

  // ============================================
  // MODUL 3: STAFFELPREIS-FUNKTIONEN
  // ============================================
  
  function parseStaffelpreise(staffelString) {
    if (!staffelString) return [];
    const staffeln = [];
    const parts = staffelString.split(';');
    
    parts.forEach(part => {
      const [range, preisStr] = part.split(':');
      if (!range || !preisStr) return;
      const preis = parseFloat(preisStr.replace(',', '.'));
      
      if (range.includes('-')) {
        const [von, bis] = range.split('-').map(n => parseInt(n.trim()));
        staffeln.push({ von, bis, preis });
      } else {
        const von = parseInt(range.trim());
        staffeln.push({ von, bis: null, preis });
      }
    });
    return staffeln;
  }

  function getStaffelpreis(staffeln, menge) {
    if (!staffeln || staffeln.length === 0) return null;
    const staffel = staffeln.find(s => menge >= s.von && (s.bis === null || menge <= s.bis));
    return staffel ? staffel.preis : staffeln[0].preis;
  }

  function getErsparnis(staffeln, staffel, uvp) {
    if (!staffeln || staffeln.length === 0) return null;
    const basisPreis = uvp || staffeln[0].preis;
    const ersparnis = ((basisPreis - staffel.preis) / basisPreis * 100).toFixed(0);
    return ersparnis > 0 ? ersparnis : null;
  }

  function formatGrundpreis(preis, einheit, quantityValue, referenceValue) {
    const qv = quantityValue || 1;
    const rv = referenceValue || 1;
    const grundpreis = (preis / qv) * rv;
    return grundpreis.toFixed(2).replace('.', ',') + ' €/' + einheit;
  }

  /**
   * v3.9.5: Ermittelt UVP für eine Variante
   * Priorität: 1. compare_at_price (wenn > 0), 2. price
   */
  function getUvpForVariant(variant) {
    if (!variant) return null;
    if (variant.compare_at_price && variant.compare_at_price > 0) {
      return variant.compare_at_price / 100;
    }
    return variant.price / 100;
  }

  /**
   * v3.9.5: Aktualisiert UVP basierend auf aktuellem Modus
   * - Einzelbestellung: UVP der ausgewählten Größe
   * - Teambestellung: UVP der ersten verfügbaren Variante
   */
  function updateUvpForCurrentSelection() {
    if (!appData.staffelpreiseAktiv) return;
    
    let targetVariant = null;
    
    if (appData.mode === 'single' && appData.selectedSize) {
      // Einzelbestellung: Preis der ausgewählten Größe
      targetVariant = appData.filteredVariants.find(v => getSizeFromVariant(v) === appData.selectedSize);
    }
    
    if (!targetVariant && appData.filteredVariants.length > 0) {
      // Teambestellung oder keine Auswahl: Erste verfügbare Variante
      targetVariant = appData.filteredVariants.find(v => v.available) || appData.filteredVariants[0];
    }
    
    if (targetVariant) {
      const newUvp = getUvpForVariant(targetVariant);
      if (newUvp !== appData.uvp) {
        appData.uvp = newUvp;
        console.log('📊 Bigtime: UVP aktualisiert:', appData.uvp + '€', '(Variante:', getSizeFromVariant(targetVariant) + ')');
      }
    }
  }

  // ============================================
  // SESSION-MANAGEMENT
  // ============================================
  
  function generateSessionId() {
    const now = new Date();
    const date = now.toISOString().slice(0, 10);
    const time = now.toTimeString().slice(0, 8).replace(/:/g, '-');
    const randomId = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    return `${date}_${time}_${randomId}`;
  }

  function getOrCreateSessionId() {
    const storageKey = 'bigtime_upload_session';
    let sessionId = localStorage.getItem(storageKey);
    const sessionTimestamp = localStorage.getItem(storageKey + '_timestamp');
    const maxAge = 24 * 60 * 60 * 1000;
    
    if (!sessionId || !sessionTimestamp || (Date.now() - parseInt(sessionTimestamp)) > maxAge) {
      sessionId = generateSessionId();
      localStorage.setItem(storageKey, sessionId);
      localStorage.setItem(storageKey + '_timestamp', Date.now().toString());
    }
    return sessionId;
  }

  // ============================================
  // MODUL 1: THEME-INTEGRATION
  // ============================================
  
  function injectSizeHidingCSS() {
    if (document.getElementById('bigtime-hide-sizes')) return;
    const style = document.createElement('style');
    style.id = 'bigtime-hide-sizes';
    style.textContent = `
      variant-picker fieldset[data-option-slug="grosse"],
      variant-picker fieldset[data-option-slug="größe"],
      variant-picker fieldset[data-option-slug="groesse"],
      variant-picker fieldset[data-option-slug="size"] { display: none !important; }
      .bigtime-active .product-form__buttons { display: none !important; }
      .bigtime-active .shopify-payment-button { display: none !important; }
      .bigtime-active product-form .product-form__submit { display: none !important; }
      .bigtime-active [data-shopify="payment-button"] { display: none !important; }
    `;
    document.head.appendChild(style);
  }

  function hideThemeAddToCart() {
    document.body.classList.add('bigtime-active');
    const selectors = [
      '.product-form__buttons', '.product-form__submit', '[name="add"]',
      '.shopify-payment-button', '.product-form__cart-submit',
      'button[type="submit"][name="add"]', '.add-to-cart', '[data-shopify="payment-button"]'
    ];
    selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        if (!el.closest('.bigtime-wrapper') && !el.classList.contains('bigtime-add-to-cart')) {
          el.style.setProperty('display', 'none', 'important');
        }
      });
    });
  }

  function hideThemeSizeSelector() {
    document.querySelectorAll('[data-option-slug="grosse"], [data-option-slug="größe"], [data-option-slug="size"], [data-option-slug="groesse"]').forEach(el => {
      el.style.setProperty('display', 'none', 'important');
    });
    document.querySelectorAll('variant-picker fieldset').forEach(fieldset => {
      const label = fieldset.querySelector('.form__label');
      if (label) {
        const text = label.textContent.toLowerCase();
        if (text.includes('größe') || text.includes('size') || text.includes('groesse') || text.includes('grösse')) {
          fieldset.style.setProperty('display', 'none', 'important');
        }
      }
    });
  }

  function setupSizeHidingObserver() {
    const variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) return;
    const observer = new MutationObserver(() => hideThemeSizeSelector());
    observer.observe(variantPicker, { childList: true, subtree: true, attributes: true });
  }

  // ============================================
  // NEU: SECTION RENDERING API FÜR 2000+ VARIANTEN
  // v3.9.1: Komplett überarbeitete Implementierung
  // ============================================
  
  /**
   * Ermittelt die Section ID aus dem DOM
   */
  function getSectionId() {
    // Methode 1: Aus dem Produkt-Container
    const productSection = document.querySelector('[id^="shopify-section-"][id*="main-product"]');
    if (productSection) {
      return productSection.id.replace('shopify-section-', '');
    }
    
    // Methode 2: Aus product-form
    const productForm = document.querySelector('product-form, form[action*="/cart/add"]');
    if (productForm) {
      const section = productForm.closest('[id^="shopify-section-"]');
      if (section && section.id.includes('product')) {
        return section.id.replace('shopify-section-', '');
      }
    }
    
    // Methode 3: Suche nach main-product Section
    const allSections = document.querySelectorAll('[id^="shopify-section-"]');
    for (const section of allSections) {
      if (section.id.includes('main-product') || (section.id.includes('product') && !section.id.includes('recommendation') && !section.id.includes('header'))) {
        return section.id.replace('shopify-section-', '');
      }
    }
    
    // Methode 4: Aus variant-picker parent
    const variantPicker = document.querySelector('variant-picker');
    if (variantPicker) {
      const parentSection = variantPicker.closest('[id^="shopify-section-"]');
      if (parentSection?.id) {
        return parentSection.id.replace('shopify-section-', '');
      }
    }
    
    return null;
  }

  /**
   * Ermittelt die Option Value ID für eine Farbe aus dem Theme
   */
  function getColorOptionValueId(color) {
    const colorFieldsets = document.querySelectorAll(
      'variant-picker fieldset[data-option-slug*="farbe"], ' +
      'variant-picker fieldset[data-option-slug*="color"], ' +
      'variant-picker fieldset[data-option-slug*="colour"]'
    );

    for (const fieldset of colorFieldsets) {
      const input = fieldset.querySelector(`input[value="${color}"]`);
      if (input?.dataset.optionValueId) {
        return input.dataset.optionValueId;
      }
    }

    return null;
  }

  /**
   * v3.9.6 NEU: Ermittelt die Option Value ID für ein Geschlecht aus dem Theme
   * (Analog zu getColorOptionValueId, nur relevant wenn appData.hasGender true ist)
   */
  function getGenderOptionValueId(gender) {
    const genderFieldsets = document.querySelectorAll(
      'variant-picker fieldset[data-option-slug*="geschlecht"], ' +
      'variant-picker fieldset[data-option-slug*="gender"]'
    );

    for (const fieldset of genderFieldsets) {
      const input = fieldset.querySelector(`input[value="${gender}"]`);
      if (input?.dataset.optionValueId) {
        return input.dataset.optionValueId;
      }
    }

    return null;
  }

  /**
   * v3.9.1 NEU: Ermittelt alle Größen mit ihren Option Value IDs
   */
  function getSizeOptionValues() {
    // Versuche über option index
    let fieldset = document.querySelector(
      `variant-picker fieldset[data-option-index="option${appData.sizeOptionIndex}"]`
    );
    
    // Fallback: Suche nach grosse/size im slug
    if (!fieldset) {
      fieldset = document.querySelector(
        'variant-picker fieldset[data-option-slug*="gro"], ' +
        'variant-picker fieldset[data-option-slug*="size"], ' +
        'variant-picker fieldset[data-option-slug*="größe"]'
      );
    }
    
    if (!fieldset) return [];
    
    const inputs = fieldset.querySelectorAll('input[data-option-value-id]');
    
    return Array.from(inputs).map(input => ({
      name: input.value,
      optionValueId: input.dataset.optionValueId
    }));
  }

  /**
   * v3.9.1 NEU: Lädt Varianten für eine Farbe via Section Rendering API
   * v3.9.2: sessionStorage Cache für Browser-Navigation
   * v3.9.3: Zurück zu parallelem Loading (schneller)
   */
  async function loadVariantsForColor(color, gender) {
    // v3.9.6: gender ist optional - nur relevant wenn appData.hasGender true ist
    const useGender = appData.hasGender && !!gender;
    const cacheKey = useGender ? `${color}||${gender}` : color;
    console.log('🔄 Bigtime: Lade Varianten für Farbe:', color, useGender ? ('| Geschlecht: ' + gender) : '');

    // 1. Check Memory-Cache
    if (appData.variantsCache[cacheKey]) {
      console.log('✅ Bigtime: aus Memory-Cache:', cacheKey, appData.variantsCache[cacheKey].length, 'Varianten');
      return appData.variantsCache[cacheKey];
    }

    // 2. Check sessionStorage-Cache (überlebt Browser-Navigation)
    const storageKey = `bigtime_variants_${appData.productHandle}_${cacheKey}`;
    try {
      const cached = sessionStorage.getItem(storageKey);
      if (cached) {
        const variants = JSON.parse(cached);
        console.log('✅ Bigtime: aus sessionStorage:', cacheKey, variants.length, 'Varianten');
        appData.variantsCache[cacheKey] = variants;
        return variants;
      }
    } catch (e) { /* sessionStorage nicht verfügbar */ }

    // 3. Prüfe ob Farbe/Geschlecht-Kombination in den ersten 250 Varianten ist
    const existingVariants = appData.variants.filter(v => {
      const variantColor = v['option' + appData.colorOptionIndex];
      if (variantColor !== color) return false;
      if (useGender) {
        return v['option' + appData.genderOptionIndex] === gender;
      }
      return true;
    });

    if (existingVariants.length > 0) {
      console.log('✅ Bigtime: in Liquid-Varianten gefunden:', existingVariants.length);
      appData.variantsCache[cacheKey] = existingVariants;
      return existingVariants;
    }

    // 4. Nicht in den 250 → Nachladen via Section Rendering API
    console.log('⚠️ Bigtime: nicht in Liquid, lade via Section Rendering API...');

    const sectionId = appData.sectionId || getSectionId();
    if (!sectionId || !appData.productHandle) {
      console.warn('❌ Bigtime: Section ID oder Product Handle fehlt');
      return [];
    }

    appData.sectionId = sectionId;

    // Farbe-optionValueId ermitteln
    const colorOptionValueId = getColorOptionValueId(color);
    if (!colorOptionValueId) {
      console.warn('❌ Bigtime: optionValueId für Farbe nicht gefunden:', color);
      return [];
    }

    // v3.9.6 NEU: Geschlecht-optionValueId ermitteln (nur wenn relevant)
    let genderOptionValueId = null;
    if (useGender) {
      genderOptionValueId = getGenderOptionValueId(gender);
      if (!genderOptionValueId) {
        console.warn('❌ Bigtime: optionValueId für Geschlecht nicht gefunden:', gender);
        return [];
      }
    }

    // Alle Größen-optionValueIds ermitteln
    const sizeOptions = getSizeOptionValues();
    if (sizeOptions.length === 0) {
      console.warn('❌ Bigtime: Keine Größen-Optionen gefunden');
      return [];
    }
    console.log('🔍 Bigtime: Lade', sizeOptions.length, 'Größen parallel...');

    // Parallele Requests für alle Größen (schnellste Methode)
    try {
      const results = await Promise.all(
        sizeOptions.map(async (sizeOpt) => {
          try {
            const optionValues = useGender
              ? `${colorOptionValueId},${genderOptionValueId},${sizeOpt.optionValueId}`
              : `${colorOptionValueId},${sizeOpt.optionValueId}`;
            const url = `/products/${appData.productHandle}?section_id=${sectionId}&option_values=${optionValues}`;

            const response = await fetch(url);
            if (!response.ok) return null;

            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');

            const jsonScript = doc.querySelector('script[type="application/json"]');
            if (!jsonScript) return null;

            const variant = JSON.parse(jsonScript.textContent);

            const colorOk = variant && variant['option' + appData.colorOptionIndex] === color;
            const genderOk = !useGender || (variant && variant['option' + appData.genderOptionIndex] === gender);
            if (colorOk && genderOk) {
              return variant;
            }
            return null;
          } catch (error) {
            return null;
          }
        })
      );

      // Null-Werte entfernen
      const validVariants = results.filter(v => v !== null);

      if (validVariants.length > 0) {
        console.log('✅ Bigtime:', validVariants.length, 'Varianten geladen');

        // In Memory-Cache speichern
        appData.variantsCache[cacheKey] = validVariants;

        // In sessionStorage speichern (für Browser-Navigation)
        try {
          sessionStorage.setItem(storageKey, JSON.stringify(validVariants));
        } catch (e) { /* sessionStorage voll oder nicht verfügbar */ }

        // Zum Hauptarray hinzufügen
        validVariants.forEach(v => {
          if (!appData.variants.find(existing => existing.id === v.id)) {
            appData.variants.push(v);
          }
        });

        return validVariants;
      }

    } catch (err) {
      console.error('❌ Bigtime: Fehler beim Laden via API:', err);
    }

    return [];
  }

  /**
   * Fallback: Extrahiert Varianten aus dem aktuellen DOM
   * (wird als Fallback behalten, aber v3.9.1 nutzt primär die API)
   */
  function extractVariantsFromCurrentDOM(targetColor) {
    const variants = [];
    
    const sizeFieldsets = document.querySelectorAll(
      'variant-picker fieldset[data-option-slug*="grosse"], ' +
      'variant-picker fieldset[data-option-slug*="größe"], ' +
      'variant-picker fieldset[data-option-slug*="size"], ' +
      'variant-picker fieldset[data-option-slug*="grösse"]'
    );
    
    sizeFieldsets.forEach(fieldset => {
      const inputs = fieldset.querySelectorAll('input[type="radio"]');
      inputs.forEach(input => {
        const size = input.value;
        const available = !input.disabled && !input.classList.contains('disabled');
        
        if (size) {
          variants.push({
            id: null, // DOM hat keine Variant-IDs
            option1: targetColor,
            option2: size,
            available: available,
            price: 0,
            title: `${targetColor} / ${size}`,
            _fromDOM: true
          });
        }
      });
    });
    
    return variants;
  }

  // ============================================
  // MODUL 1: VARIANTEN & FARBEN
  // ============================================
  
  function analyzeProductOptions(variants) {
    if (!variants || variants.length === 0) return;
    
    const variantPicker = document.querySelector('variant-picker');
    if (variantPicker) {
      variantPicker.querySelectorAll('fieldset[data-option-index]').forEach(fieldset => {
        const optionIndex = fieldset.dataset.optionIndex;
        const optionSlug = fieldset.dataset.optionSlug;
        const indexNum = parseInt(optionIndex.replace('option', ''));
        
        if (optionSlug) {
          const slug = optionSlug.toLowerCase();
          if (slug.includes('farbe') || slug.includes('color') || slug.includes('colour')) {
            appData.colorOptionIndex = indexNum;
            appData.hasColors = true;
          } else if (slug.includes('größe') || slug.includes('grosse') || slug.includes('size') || slug.includes('grösse')) {
            appData.sizeOptionIndex = indexNum;
          } else if (slug.includes('geschlecht') || slug.includes('gender')) {
            // v3.9.6 NEU: Geschlecht nur über den nativen Options-Slug erkennen,
            // NIE erraten (anders als Farbe/Größe im Fallback unten) - zu riskant.
            appData.genderOptionIndex = indexNum;
            appData.hasGender = true;
          }
        }
      });
    }
    
    if (!appData.colorOptionIndex && !appData.sizeOptionIndex) {
      const firstVariant = variants[0];
      for (let i = 1; i <= 3; i++) {
        const optionValue = firstVariant['option' + i];
        if (!optionValue) continue;
        if (SIZE_ORDER.some(s => s.toUpperCase() === optionValue.toUpperCase())) {
          appData.sizeOptionIndex = i;
        } else if (!appData.colorOptionIndex) {
          appData.colorOptionIndex = i;
          appData.hasColors = true;
        }
      }
    }
    
    // Sammle ALLE Farben aus dem Theme (nicht nur aus den 250 Varianten)
    if (appData.hasColors) {
      const colors = new Set();
      
      // Aus Theme-Farbauswahl
      const colorFieldsets = document.querySelectorAll('variant-picker fieldset[data-option-slug*="farbe"], variant-picker fieldset[data-option-slug*="color"], variant-picker fieldset[data-option-slug*="colour"]');
      colorFieldsets.forEach(fieldset => {
        fieldset.querySelectorAll('input[type="radio"]').forEach(input => {
          if (input.value) colors.add(input.value);
        });
      });
      
      // Fallback: Aus Varianten
      if (colors.size === 0) {
        variants.forEach(v => {
          const color = v['option' + appData.colorOptionIndex];
          if (color) colors.add(color);
        });
      }
      
      appData.availableColors = Array.from(colors);
      console.log('🎨 Bigtime: Verfügbare Farben:', appData.availableColors.length);
    }

    // v3.9.6 NEU: Sammle ALLE Geschlecht-Werte aus dem Theme (nur wenn Produkt die Option hat)
    if (appData.hasGender) {
      const genders = new Set();
      const genderFieldsets = document.querySelectorAll('variant-picker fieldset[data-option-slug*="geschlecht"], variant-picker fieldset[data-option-slug*="gender"]');
      genderFieldsets.forEach(fieldset => {
        fieldset.querySelectorAll('input[type="radio"]').forEach(input => {
          if (input.value) genders.add(input.value);
        });
      });

      if (genders.size === 0) {
        variants.forEach(v => {
          const gender = v['option' + appData.genderOptionIndex];
          if (gender) genders.add(gender);
        });
      }

      appData.availableGenders = Array.from(genders);
      console.log('🚻 Bigtime: Verfügbare Geschlechter:', appData.availableGenders.length);
    }
  }

  /**
   * v3.9.6: Filtert Varianten nach Farbe UND (sofern vorhanden) Geschlecht.
   * Name bleibt "filterVariantsByColor" (statt Umbenennung), um alle bestehenden
   * Aufrufstellen minimal-invasiv zu halten - Gender-Parameter ist optional.
   */
  function filterVariantsByColor(variants, color, gender) {
    let result = variants;
    if (color && appData.colorOptionIndex) {
      result = result.filter(v => v['option' + appData.colorOptionIndex] === color);
    }
    if (appData.hasGender && gender && appData.genderOptionIndex) {
      result = result.filter(v => v['option' + appData.genderOptionIndex] === gender);
    }
    return result;
  }

  function getSizeFromVariant(variant) {
    if (appData.sizeOptionIndex) return variant['option' + appData.sizeOptionIndex];
    for (let i = 1; i <= 3; i++) {
      const opt = variant['option' + i];
      if (opt && SIZE_ORDER.some(s => s.toUpperCase() === String(opt).toUpperCase())) return opt;
    }
    return variant.option2 || variant.option1;
  }

  function getCurrentColorFromTheme() {
    const colorFieldset = document.querySelector('[data-option-slug="farbe"], [data-option-slug="color"], [data-option-slug="colour"]');
    if (colorFieldset) {
      const checkedRadio = colorFieldset.querySelector('input[type="radio"]:checked');
      if (checkedRadio) return checkedRadio.value;
    }
    const colorRadio = document.querySelector('input[name*="Farbe-"]:checked, input[name*="Color-"]:checked, input[name*="farbe-"]:checked');
    if (colorRadio) return colorRadio.value;
    if (appData.availableColors.length > 0) return appData.availableColors[0];
    return null;
  }

  /**
   * v3.9.6 NEU: Analog zu getCurrentColorFromTheme, nur für Geschlecht.
   * Kein Auto-Fallback auf "erstes verfügbares Geschlecht" - der Kunde soll
   * aktiv wählen (siehe Hinweistext in renderApp).
   */
  function getCurrentGenderFromTheme() {
    if (!appData.hasGender) return null;
    const genderFieldset = document.querySelector('[data-option-slug="geschlecht"], [data-option-slug="gender"]');
    if (genderFieldset) {
      const checkedRadio = genderFieldset.querySelector('input[type="radio"]:checked');
      if (checkedRadio) return checkedRadio.value;
    }
    const genderRadio = document.querySelector('input[name*="Geschlecht-"]:checked, input[name*="Gender-"]:checked, input[name*="geschlecht-"]:checked');
    if (genderRadio) return genderRadio.value;
    return null;
  }

  /**
   * ANGEPASST: watchColorChanges mit Section Rendering API Support
   * v3.9.6: Reagiert jetzt zusätzlich auf Geschlecht-Wechsel (sofern appData.hasGender),
   * Farbe UND Geschlecht filtern gemeinsam die Größen-Liste.
   */
  function watchColorChanges() {
    document.addEventListener('change', async (e) => {
      if (e.target.type !== 'radio') return;
      const fieldset = e.target.closest('fieldset[data-option-slug]');
      if (!fieldset) return;

      const slug = fieldset.dataset.optionSlug?.toLowerCase() || '';
      const isColorChange = slug.includes('farbe') || slug.includes('color') || slug.includes('colour');
      const isGenderChange = appData.hasGender && (slug.includes('geschlecht') || slug.includes('gender'));
      if (!isColorChange && !isGenderChange) return;

      if (appData.gruppe) hideThemeSizeSelector();

      const newColor = isColorChange ? e.target.value : appData.selectedColor;
      const newGender = isGenderChange ? e.target.value : appData.selectedGender;
      if (newColor === appData.selectedColor && newGender === appData.selectedGender) return;

      console.log('🎨 Bigtime: Auswahl geändert - Farbe:', newColor, '| Geschlecht:', newGender);

      appData.selectedColor = newColor;
      appData.selectedGender = newGender;
      appData.selectedSize = null;
      appData.teamQuantities = {};
      appData.variantsLoading = true;

      // Zeige Loading-State
      renderApp();

      // Lade Varianten für neue Farbe/Geschlecht-Kombination
      const newVariants = await loadVariantsForColor(newColor, newGender);

      appData.filteredVariants = newVariants.length > 0 ? newVariants : filterVariantsByColor(appData.variants, newColor, newGender);
      appData.variantsLoading = false;

      console.log('✅ Bigtime: Gefilterte Varianten:', appData.filteredVariants.length);

      renderApp();
    });
  }

  // ============================================
  // MODUL 1: MENGEN-BERECHNUNGEN
  // ============================================
  
  function getTotalItems() {
    if (appData.mode === 'single') return appData.selectedSize ? appData.singleQuantity : 0;
    return Object.values(appData.teamQuantities).reduce((sum, qty) => sum + qty, 0);
  }

  function getItemsList() {
    const items = [];
    if (appData.mode === 'single') {
      if (appData.selectedSize) {
        for (let i = 0; i < appData.singleQuantity; i++) items.push({ size: appData.selectedSize, index: i + 1 });
      }
    } else {
      const sortedSizes = Object.keys(appData.teamQuantities).filter(size => appData.teamQuantities[size] > 0).sort((a, b) => getSizeIndex(a) - getSizeIndex(b));
      let globalIndex = 1;
      sortedSizes.forEach(size => {
        for (let i = 0; i < appData.teamQuantities[size]; i++) items.push({ size, index: globalIndex++ });
      });
    }
    return items;
  }

  // ============================================
  // MODUL 2: FILE-UPLOAD
  // ============================================
  
  async function uploadFile(file, optionId) {
    const option = appData.gruppe?.optionen?.find(o => o.id === optionId);
    const optionName = option?.beschreibung || 'upload';
    const optionSlug = optionName.toLowerCase().replace(/[äöüß]/g, c => ({ä:'ae',ö:'oe',ü:'ue',ß:'ss'}[c])).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    
    const formData = new FormData();
    formData.append('file', file);
    formData.append('sessionId', appData.sessionId);
    formData.append('productHandle', appData.productHandle);
    formData.append('optionSlug', optionSlug);

    const response = await fetch(UPLOAD_API_URL, { method: 'POST', body: formData });
    if (!response.ok) { const err = await response.json(); throw new Error(err.error || 'Upload fehlgeschlagen'); }
    const result = await response.json();
    if (result.folder?.consoleUrl) appData.folderConsoleUrl = result.folder.consoleUrl;
    return result.file;
  }

  async function deleteFile(publicId, optionId) {
    const response = await fetch(`${UPLOAD_API_URL}/${encodeURIComponent(publicId)}`, { method: 'DELETE' });
    if (!response.ok) throw new Error('Löschen fehlgeschlagen');
    if (appData.uploadedFiles[optionId]) appData.uploadedFiles[optionId] = appData.uploadedFiles[optionId].filter(f => f.publicId !== publicId);
    renderApp();
  }

  async function handleFileSelectWithValidation(fileList, optionId) {
    const files = Array.from(fileList);
    if (files.length === 0) return;
    if (!appData.uploadedFiles[optionId]) appData.uploadedFiles[optionId] = [];
    
    const currentCount = appData.uploadedFiles[optionId].length;
    if (currentCount + files.length > 5) { showUploadError(optionId, `Maximal 5 Dateien. Du hast bereits ${currentCount}.`); return; }
    
    const invalidFiles = [], validFiles = [];
    for (const file of files) {
      if (file.size > 10 * 1024 * 1024) { invalidFiles.push(`"${file.name}" zu groß (max 10MB)`); continue; }
      if (!isFileAllowed(file.name)) { invalidFiles.push(`"${file.name}" Format nicht erlaubt`); continue; }
      validFiles.push(file);
    }
    if (invalidFiles.length > 0) showUploadError(optionId, invalidFiles.join('<br>'));
    if (validFiles.length === 0) return;
    
    const loadingEl = document.getElementById(`upload-loading-${optionId}`);
    if (loadingEl) loadingEl.style.display = 'flex';
    
    for (const file of validFiles) {
      try { appData.uploadedFiles[optionId].push(await uploadFile(file, optionId)); }
      catch (err) { showUploadError(optionId, `Fehler: ${err.message}`); }
    }
    if (loadingEl) loadingEl.style.display = 'none';
    renderApp();
  }

  function showUploadError(optionId, message) {
    const el = document.getElementById(`upload-error-${optionId}`);
    if (el) { el.innerHTML = message; el.style.display = 'flex'; setTimeout(() => el.style.display = 'none', 8000); }
  }

  function getAllUploadedFiles() {
    const allFiles = [];
    Object.entries(appData.uploadedFiles).forEach(([optionId, files]) => {
      const option = appData.gruppe?.optionen?.find(o => o.id === parseInt(optionId));
      files.forEach(file => allFiles.push({ optionName: option?.beschreibung || 'Datei', fileName: file.originalName, url: file.url }));
    });
    return allFiles;
  }

  // ============================================
  // STYLES
  // ============================================
  
  function injectStyles() {
    if (document.getElementById('bigtime-styles')) return;
    const styles = document.createElement('style');
    styles.id = 'bigtime-styles';
    styles.textContent = `
      .bigtime-wrapper{font-family:inherit;max-width:100%;margin:20px 0}
      .bigtime-loading{display:flex;align-items:center;justify-content:center;padding:40px;gap:12px;color:#666}
      .bigtime-loading-spinner{width:24px;height:24px;border:3px solid #e5e5e5;border-top-color:#0d9488;border-radius:50%;animation:bigtime-spin .8s linear infinite}
      .bigtime-staffelpreise{background:linear-gradient(135deg,#f0fdfa 0%,#ccfbf1 100%);border-radius:12px;padding:16px;margin-bottom:20px}
      .bigtime-staffel-title{font-size:14px;font-weight:600;color:#0d9488;margin-bottom:12px}
      .bigtime-staffel-table{width:100%;border-collapse:collapse;font-size:14px}
      .bigtime-staffel-table thead tr{border-bottom:1px solid rgba(13,148,136,0.2)}
      .bigtime-staffel-table th{padding:6px 8px;font-size:11px;font-weight:500;color:#6b7280;text-transform:uppercase;letter-spacing:0.5px}
      .bigtime-staffel-table th.col-anzahl{text-align:left}
      .bigtime-staffel-table th.col-uvp{text-align:center}
      .bigtime-staffel-table th.col-preis,.bigtime-staffel-table th.col-rabatt,.bigtime-staffel-table th.col-grundpreis{text-align:right}
      .bigtime-staffel-table tbody tr{transition:all .3s ease}
      .bigtime-staffel-table tbody tr.staffel-aktiv{background:#0d9488;color:#fff}
      .bigtime-staffel-table tbody tr.staffel-aktiv td:first-child{border-radius:8px 0 0 8px}
      .bigtime-staffel-table tbody tr.staffel-aktiv td:last-child{border-radius:0 8px 8px 0}
      .bigtime-staffel-table td{padding:10px 8px}
      .bigtime-staffel-table .staffel-anzahl{color:#374151;font-weight:500}
      .bigtime-staffel-table tr.staffel-aktiv .staffel-anzahl{color:#fff}
      .bigtime-staffel-table .staffel-uvp{text-align:center;color:#9ca3af;text-decoration:line-through}
      .bigtime-staffel-table tr.staffel-aktiv .staffel-uvp{color:rgba(255,255,255,0.7)}
      .bigtime-staffel-table .staffel-preis{text-align:right;font-weight:600}
      .bigtime-staffel-table .staffel-rabatt{text-align:right}
      .bigtime-staffel-table .staffel-grundpreis{text-align:right;font-size:12px;color:#6b7280}
      .bigtime-staffel-table tr.staffel-aktiv .staffel-grundpreis{color:rgba(255,255,255,0.9)}
      .bigtime-staffel-table .rabatt-badge{background:#dcfce7;color:#16a34a;padding:2px 8px;border-radius:12px;font-size:11px;font-weight:500}
      .bigtime-staffel-table tr.staffel-aktiv .rabatt-badge{background:rgba(255,255,255,0.2);color:#fff}
      .bigtime-staffel-grundpreis-mobile{display:none;font-size:12px;color:#6b7280;margin-top:8px;padding-top:8px;border-top:1px solid rgba(13,148,136,0.2)}
      @media(max-width:600px){.bigtime-staffel-table th.col-grundpreis,.bigtime-staffel-table td.staffel-grundpreis{display:none}.bigtime-staffel-grundpreis-mobile{display:block}}
      .bigtime-tabs{display:flex;gap:10px;margin-bottom:20px;flex-wrap:wrap}
      .bigtime-tab{padding:12px 24px;border:2px solid #e5e5e5;background:#fff;cursor:pointer;border-radius:30px;font-weight:500;transition:all .2s;font-size:14px}
      .bigtime-tab:hover{border-color:#0d9488}
      .bigtime-tab.active{background:#0d9488;color:#fff;border-color:#0d9488}
      .bigtime-size-tiles{display:flex;flex-wrap:wrap;gap:10px;margin-bottom:20px}
      .bigtime-size-tile{padding:12px 20px;border:2px solid #e5e5e5;background:#fff;cursor:pointer;border-radius:8px;text-align:center;min-width:60px;transition:all .2s}
      .bigtime-size-tile:hover:not(.disabled){border-color:#0d9488}
      .bigtime-size-tile.selected{border-color:#0d9488;background:#f0fdfa}
      .bigtime-size-tile.disabled{opacity:.4;cursor:not-allowed;text-decoration:line-through}
      .bigtime-size-tile .size-name{font-weight:600;font-size:14px}
      .bigtime-size-tile .size-price{font-size:12px;color:#666;margin-top:4px}
      .bigtime-quantity-control{display:flex;align-items:center;gap:15px;margin:20px 0;padding:15px;background:#f9f9f9;border-radius:8px}
      .bigtime-quantity-control label{font-weight:500}
      .bigtime-qty-wrapper{display:flex;align-items:center;border:1px solid #ddd;border-radius:8px;overflow:hidden}
      .bigtime-qty-btn{width:40px;height:40px;border:none;background:#f5f5f5;cursor:pointer;font-size:18px;transition:background .2s}
      .bigtime-qty-btn:hover{background:#e5e5e5}
      .bigtime-qty-input{width:60px;height:40px;border:none;text-align:center;font-size:16px;font-weight:500;-moz-appearance:textfield}
      .bigtime-qty-input::-webkit-outer-spin-button,.bigtime-qty-input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}
      .bigtime-table-wrapper{overflow-x:auto;margin-bottom:20px}
      .bigtime-size-table{width:100%;border-collapse:collapse;min-width:300px}
      .bigtime-size-table th,.bigtime-size-table td{padding:12px;text-align:left;border-bottom:1px solid #eee}
      .bigtime-size-table th{font-weight:600;background:#f9f9f9}
      .bigtime-size-table .qty-cell{display:flex;align-items:center;gap:8px}
      .bigtime-size-table .qty-btn{width:32px;height:32px;border:1px solid #ddd;background:#fff;cursor:pointer;border-radius:6px;font-size:16px}
      .bigtime-size-table .qty-btn:hover{background:#f5f5f5}
      .bigtime-size-table .qty-input{width:50px;height:32px;border:1px solid #ddd;border-radius:6px;text-align:center;font-weight:500;-moz-appearance:textfield}
      .bigtime-size-table .qty-input::-webkit-outer-spin-button,.bigtime-size-table .qty-input::-webkit-inner-spin-button{-webkit-appearance:none}
      .bigtime-size-table .qty-input:focus{outline:none;border-color:#0d9488}
      .bigtime-size-table .unavailable{color:#999;font-style:italic}
      .bigtime-size-table .stock-ausverkauft{color:#be123c;font-weight:600;font-style:normal}
      .bigtime-size-table .stock-datum{color:#000;font-weight:600;font-style:normal}
      .bigtime-options{margin:25px 0;padding-top:20px;border-top:1px solid #eee}
      .bigtime-options-title{font-size:16px;font-weight:600;margin-bottom:15px}
      .bigtime-option{margin-bottom:10px;padding:12px 15px;background:#f9f9f9;border-radius:8px}
      .bigtime-checkbox-label{display:flex;align-items:center;gap:12px;cursor:pointer;font-weight:500}
      .bigtime-checkbox-label input[type="checkbox"]{display:none}
      .bigtime-checkbox-custom{width:22px;height:22px;border:2px solid #ccc;border-radius:4px;display:flex;align-items:center;justify-content:center;transition:all .2s;flex-shrink:0}
      .bigtime-checkbox-label input:checked+.bigtime-checkbox-custom{background:#0d9488;border-color:#0d9488}
      .bigtime-checkbox-label input:checked+.bigtime-checkbox-custom::after{content:'✓';color:#fff;font-size:14px}
      .bigtime-option-price{color:#0d9488;font-weight:600;margin-left:auto}
      .bigtime-pflicht{color:#dc2626;margin-left:4px}
      .bigtime-textfield-container{margin-top:15px;padding-left:34px}
      .bigtime-textfield{width:100%;padding:10px 12px;border:1px solid #ddd;border-radius:6px;font-size:14px;box-sizing:border-box}
      .bigtime-textfield:focus{outline:none;border-color:#0d9488}
      .bigtime-article-fields{margin-top:20px;padding-top:20px;border-top:1px solid #eee}
      .bigtime-article-fields-title{font-size:16px;font-weight:600;margin-bottom:15px;color:#333}
      .bigtime-article-card{margin-bottom:12px;padding:15px;background:#fff;border-radius:10px;border:1px solid #e5e5e5;box-shadow:0 1px 3px rgba(0,0,0,0.05)}
      .bigtime-article-card-header{font-weight:600;font-size:14px;color:#0d9488;margin-bottom:12px;padding-bottom:8px;border-bottom:1px solid #f0f0f0;display:flex;align-items:center;gap:8px}
      .bigtime-article-card-header .article-number{background:#0d9488;color:#fff;width:24px;height:24px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:12px}
      .bigtime-article-card-header .article-size{background:#f0fdfa;color:#0d9488;padding:2px 8px;border-radius:4px;font-size:12px}
      .bigtime-article-field{margin-bottom:10px}
      .bigtime-article-field:last-child{margin-bottom:0}
      .bigtime-article-field-label{font-size:12px;color:#666;margin-bottom:4px;font-weight:500}
      .bigtime-file-upload-container{margin-top:15px;padding-left:34px}
      .bigtime-drop-zone{position:relative;margin-bottom:12px;text-align:center}
      .bigtime-file-input{position:absolute;width:1px;height:1px;opacity:0}
      .bigtime-drop-zone-label{display:block;background:linear-gradient(135deg,#f0fdfa,#fff);border:2px solid #e0f2f1;border-radius:12px;padding:25px 20px;cursor:pointer;transition:all .3s}
      .bigtime-drop-zone.dragover .bigtime-drop-zone-label,.bigtime-drop-zone-label:hover{border-color:#0d9488;box-shadow:0 4px 12px rgba(13,148,136,0.15)}
      .bigtime-drop-zone-icon{width:48px;height:48px;background:#0d9488;border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 12px;color:#fff;font-size:20px;font-weight:bold}
      .bigtime-drop-zone-text{color:#333;font-size:15px;font-weight:500}
      .bigtime-drop-zone-text span{color:#0d9488}
      .bigtime-drop-zone-hint{color:#999;font-size:12px;margin-top:6px}
      .bigtime-formats-toggle{display:inline-flex;align-items:center;gap:6px;margin-top:10px;padding:6px 12px;background:transparent;border:1px solid #e5e5e5;border-radius:20px;color:#666;font-size:12px;cursor:pointer}
      .bigtime-formats-toggle:hover{border-color:#0d9488;color:#0d9488}
      .bigtime-formats-info{background:#f9fafb;border:1px solid #e5e5e5;border-radius:8px;padding:12px;margin-bottom:12px;font-size:12px;color:#666;line-height:1.6}
      .bigtime-upload-error{background:#fef2f2;border:1px solid #fecaca;color:#dc2626;padding:10px 15px;border-radius:8px;margin-bottom:12px;font-size:13px;display:none;align-items:center;gap:8px}
      .bigtime-upload-error::before{content:'⚠️'}
      .bigtime-file-list{margin-bottom:12px}
      .bigtime-file-item{display:flex;align-items:center;justify-content:space-between;padding:10px 12px;background:#f9fafb;border-radius:8px;margin-bottom:6px}
      .bigtime-file-info{flex:1;min-width:0;display:flex;align-items:center;gap:10px}
      .bigtime-file-name{font-size:13px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
      .bigtime-file-size{font-size:11px;color:#999}
      .bigtime-file-delete{width:28px;height:28px;border:none;background:transparent;color:#999;cursor:pointer;border-radius:6px;font-size:14px}
      .bigtime-file-delete:hover{background:#fef2f2;color:#dc2626}
      .bigtime-upload-counter{display:flex;justify-content:space-between;font-size:12px;color:#666;margin-bottom:12px}
      .bigtime-upload-count{background:#f0fdfa;color:#0d9488;padding:4px 10px;border-radius:12px;font-weight:500}
      .bigtime-upload-comment{margin-top:15px}
      .bigtime-upload-comment label{display:block;font-size:13px;font-weight:500;margin-bottom:6px}
      .bigtime-upload-textarea{width:100%;padding:12px;border:1px solid #e5e5e5;border-radius:8px;font-size:14px;resize:vertical;min-height:80px;box-sizing:border-box}
      .bigtime-upload-textarea:focus{outline:none;border-color:#0d9488}
      .bigtime-upload-loading{display:none;align-items:center;gap:8px;padding:10px;color:#666;font-size:13px}
      .bigtime-upload-spinner{width:16px;height:16px;border:2px solid #e5e5e5;border-top-color:#0d9488;border-radius:50%;animation:bigtime-spin .8s linear infinite}
      .bigtime-no-items-hint{color:#999;font-style:italic;padding:15px;background:#f9f9f9;border-radius:8px;text-align:center}
      .bigtime-summary{margin:25px 0;padding:20px;background:#f0fdfa;border-radius:12px;border:1px solid #0d9488}
      .bigtime-summary-title{font-weight:600;margin-bottom:15px;font-size:16px}
      .bigtime-summary-row{display:flex;justify-content:space-between;padding:8px 0;border-bottom:1px solid #e0f2f1}
      .bigtime-summary-row:last-child{border-bottom:none}
      .bigtime-summary-total{font-weight:700;font-size:18px;margin-top:10px;padding-top:10px;border-top:2px solid #0d9488}
      .bigtime-error{background:#fef2f2;border:1px solid #fecaca;color:#dc2626;padding:15px;border-radius:8px;margin-bottom:15px}
      .bigtime-add-to-cart{width:100%;padding:16px 32px;background:#0d9488;color:#fff;border:none;border-radius:30px;font-size:16px;font-weight:600;cursor:pointer;transition:all .2s}
      .bigtime-add-to-cart:hover:not(:disabled){background:#0f766e}
      .bigtime-add-to-cart:disabled{background:#ccc;cursor:not-allowed}
      .bigtime-add-to-cart.loading{position:relative;color:transparent}
      .bigtime-add-to-cart.loading::after{content:'';position:absolute;width:20px;height:20px;top:50%;left:50%;margin:-10px 0 0 -10px;border:2px solid #fff;border-top-color:transparent;border-radius:50%;animation:bigtime-spin .8s linear infinite}
      @keyframes bigtime-spin{to{transform:rotate(360deg)}}
      .bigtime-color-info{background:#f0fdfa;padding:10px 15px;border-radius:8px;margin-bottom:15px;font-size:14px}
      .bigtime-color-hint{background:#fef3c7;border:1px solid #f59e0b;padding:12px 15px;border-radius:8px;margin-bottom:15px;font-size:14px;display:flex;align-items:center;gap:10px;color:#92400e}
      @media(max-width:600px){.bigtime-tabs{flex-direction:column}.bigtime-tab{text-align:center}.bigtime-size-table .stock-col{display:none}.bigtime-summary{padding:15px}.bigtime-summary-row{flex-direction:column;gap:5px}.bigtime-quantity-control{flex-direction:column;align-items:flex-start}.bigtime-file-upload-container{padding-left:0}}
    `;
    document.head.appendChild(styles);
  }

  // ============================================
  // RENDER: MODUL 3 - STAFFELPREIS-TABELLE
  // ============================================
  
  function renderStaffelpreisTabelle(currentQty) {
    if (!appData.staffelpreiseAktiv || appData.staffeln.length === 0) return '';
    
    const { staffeln, einheit, uvp, hatGrundpreis, quantityValue, referenceValue } = appData;
    const aktuelleStaffel = staffeln.find(s => currentQty >= s.von && (s.bis === null || currentQty <= s.bis)) || staffeln[0];
    
    let html = `<div class="bigtime-staffelpreise"><div class="bigtime-staffel-title">Mengenrabatt</div>
      <table class="bigtime-staffel-table"><thead><tr>
        <th class="col-anzahl">Anzahl</th><th class="col-uvp">UVP</th><th class="col-preis">Stückpreis</th><th class="col-rabatt">Rabatt</th>
        ${hatGrundpreis ? '<th class="col-grundpreis">Grundpreis</th>' : ''}
      </tr></thead><tbody>`;
    
    staffeln.forEach(staffel => {
      const isAktiv = currentQty >= staffel.von && (staffel.bis === null || currentQty <= staffel.bis);
      const ersparnis = getErsparnis(staffeln, staffel, uvp);
      const rangeText = staffel.bis ? `${staffel.von}-${staffel.bis} ${einheit}` : `ab ${staffel.von} ${einheit}`;
      html += `<tr class="${isAktiv ? 'staffel-aktiv' : ''}">
        <td class="staffel-anzahl">${rangeText}</td>
        <td class="staffel-uvp">${uvp ? formatPriceEuro(uvp) : ''}</td>
        <td class="staffel-preis">${formatPriceEuro(staffel.preis)}</td>
        <td class="staffel-rabatt">${ersparnis ? `<span class="rabatt-badge">-${ersparnis}%</span>` : '—'}</td>
        ${hatGrundpreis ? `<td class="staffel-grundpreis">${formatGrundpreis(staffel.preis, einheit, quantityValue, referenceValue)}</td>` : ''}
      </tr>`;
    });
    
    html += `</tbody></table>`;
    if (hatGrundpreis) html += `<div class="bigtime-staffel-grundpreis-mobile">Grundpreis: ${formatGrundpreis(aktuelleStaffel.preis, einheit, quantityValue, referenceValue)}</div>`;
    return html + `</div>`;
  }

  // ============================================
  // RENDER: MODUL 1 - HAUPTMODUL
  // ============================================
  
  function renderFarbInfo() {
    if (!appData.selectedColor || !appData.hasColors || appData.selectedColor === 'Default Title') return '';
    return `<div class="bigtime-color-info">Gewählte Farbe: <strong>${appData.selectedColor}</strong></div>`;
  }

  /**
   * v3.9.6 NEU: Analog zu renderFarbInfo, nur für Geschlecht.
   */
  function renderGenderInfo() {
    if (!appData.hasGender || !appData.selectedGender) return '';
    return `<div class="bigtime-color-info">Gewähltes Geschlecht: <strong>${appData.selectedGender}</strong></div>`;
  }

  function renderModusTabs() {
    return `<div class="bigtime-tabs">
      <button class="bigtime-tab ${appData.mode === 'single' ? 'active' : ''}" data-mode="single">👤 Einzelbestellung</button>
      <button class="bigtime-tab ${appData.mode === 'team' ? 'active' : ''}" data-mode="team">👥 Teambestellung</button>
    </div>`;
  }

  function renderGroessenTiles(variants) {
    const sorted = [...variants].sort((a, b) => getSizeIndex(getSizeFromVariant(a)) - getSizeIndex(getSizeFromVariant(b)));
    if (!appData.selectedSize) { const first = sorted.find(v => v.available); if (first) appData.selectedSize = getSizeFromVariant(first); }
    
    let html = '<div class="bigtime-size-tiles">';
    sorted.forEach(v => {
      const size = getSizeFromVariant(v);
      html += `<div class="bigtime-size-tile ${appData.selectedSize === size ? 'selected' : ''} ${!v.available ? 'disabled' : ''}" 
        data-size="${size}" ${!v.available ? 'data-disabled="true"' : ''}>
        <div class="size-name">${size}</div><div class="size-price">${formatPrice(v.price)}</div>
      </div>`;
    });
    return html + '</div>';
  }

  /**
   * Lieferzeit-Info für die Verfügbar-Spalte der Teambestellungs-Tabelle.
   * Liest das DOM des Snippets bigtime-lieferzeit.liquid (SSOT: knowledge/technical/lieferzeit-system.md).
   * Rückgabe: { status: 'normal'|'aus'|'datum', html }. Ohne Snippet-DOM: Fallback ✓ / Ausverkauft.
   */
  function getLieferzeitInfo(v) {
    const esc = s => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const fallback = { status: 'fallback', html: v.available ? '✓' : '<span class="unavailable">Ausverkauft</span>' };
    try {
      const root = document.querySelector('[data-bt-lz]');
      if (!root) return fallback;
      if (v.id) {
        const box = root.querySelector(`[data-bt-lz-variant="${v.id}"]`);
        if (box) {
          if (box.classList.contains('bt-lz__box--datum')) {
            const t = (box.querySelector('.bt-lz__text')?.textContent || '').trim().replace(/^Wieder\s+verfügbar/i, 'Verfügbar');
            if (t) return { status: 'datum', html: `<span class="stock-datum">${esc(t)}</span>` };
          } else if (box.classList.contains('bt-lz__box--aus')) {
            return { status: 'aus', html: '<span class="stock-ausverkauft">Ausverkauft</span>' };
          }
        }
      }
      if (!v.available) return { status: 'aus', html: '<span class="stock-ausverkauft">Ausverkauft</span>' };
      const strong = root.querySelector('[data-bt-lz-zeiten] .bt-lz__row .bt-lz__text strong');
      const zeit = (strong?.textContent || '').trim();
      return zeit ? { status: 'normal', html: esc(zeit) } : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function renderGroessenTabelle(variants) {
    const sorted = [...variants].sort((a, b) => getSizeIndex(getSizeFromVariant(a)) - getSizeIndex(getSizeFromVariant(b)));
    
    // v3.9.5: Aktuellen Staffelpreis für Gesamtmenge berechnen
    const totalQty = getTotalItems();
    const staffelpreis = appData.staffelpreiseAktiv ? getStaffelpreis(appData.staffeln, totalQty || 1) : null;
    
    let html = `<div class="bigtime-table-wrapper"><table class="bigtime-size-table">
      <thead><tr><th>Größe</th><th class="price-col">Preis</th><th class="stock-col">Verfügbar</th><th>Menge</th></tr></thead><tbody>`;
    sorted.forEach(v => {
      const size = getSizeFromVariant(v), qty = appData.teamQuantities[size] || 0;
      // Staffelpreis anzeigen wenn aktiv, sonst Variantenpreis
      const displayPrice = staffelpreis ? staffelpreis * 100 : v.price;
      const lz = getLieferzeitInfo(v);
      const kaufbar = lz.status === 'datum' ? true : (lz.status === 'aus' ? false : v.available);
      html += `<tr><td><strong>${size}</strong></td><td class="price-col">${formatPrice(displayPrice)}</td>
        <td class="stock-col">${lz.html}</td>
        <td>${kaufbar ? `<div class="qty-cell"><button class="qty-btn" data-size="${size}" data-action="decrease">−</button>
          <input type="number" class="qty-input" data-size="${size}" value="${qty}" min="0" max="999">
          <button class="qty-btn" data-size="${size}" data-action="increase">+</button></div>` : '<span class="unavailable">—</span>'}</td></tr>`;
    });
    return html + '</tbody></table></div>';
  }

  function renderMengenInput(qty) {
    return `<div class="bigtime-quantity-control"><label>Menge:</label>
      <div class="bigtime-qty-wrapper"><button class="bigtime-qty-btn" data-action="decrease">−</button>
        <input type="number" class="bigtime-qty-input" value="${qty}" min="1" max="999">
        <button class="bigtime-qty-btn" data-action="increase">+</button></div></div>`;
  }

  /**
   * NEU: Loading-State für Varianten-Laden
   */
  function renderLoadingState() {
    return `<div class="bigtime-loading">
      <span class="bigtime-loading-spinner"></span>
      <span>Lade Größen für gewählte Farbe...</span>
    </div>`;
  }

  // ============================================
  // RENDER: MODUL 2 - VEREDELUNG
  // ============================================
  
  function renderFileUpload(option) {
    const id = option.id, files = appData.uploadedFiles[id] || [], canAdd = files.length < 5;
    let html = `<div class="bigtime-file-upload-container" id="upload-container-${id}">`;
    if (canAdd) {
      html += `<div class="bigtime-drop-zone" data-option-id="${id}">
        <input type="file" class="bigtime-file-input" id="file-input-${id}" data-option-id="${id}" accept="${ALLOWED_ACCEPT}" multiple>
        <label for="file-input-${id}" class="bigtime-drop-zone-label"><div class="bigtime-drop-zone-icon">↑</div>
          <div class="bigtime-drop-zone-text">Druckdateien <span>hochladen</span></div>
          <div class="bigtime-drop-zone-hint">Ziehen & Ablegen oder klicken</div></label>
        <button type="button" class="bigtime-formats-toggle" data-option-id="${id}">Erlaubte Formate</button></div>
        <div class="bigtime-formats-info" id="formats-info-${id}" style="display:none;"><strong>Formate:</strong> Cdr, JPG, PNG, PDF, AI, EPS, SVG, TIFF, CSV, XLS<br><strong>Max:</strong> 10 MB/Datei, 5 Dateien</div>`;
    }
    html += `<div class="bigtime-upload-error" id="upload-error-${id}"></div>
      <div class="bigtime-upload-loading" id="upload-loading-${id}"><span class="bigtime-upload-spinner"></span>Wird hochgeladen...</div>`;
    if (files.length > 0) {
      html += '<div class="bigtime-file-list">';
      files.forEach(f => { html += `<div class="bigtime-file-item"><div class="bigtime-file-info"><span class="bigtime-file-name">${f.originalName}</span><span class="bigtime-file-size">${formatFileSize(f.size)}</span></div><button type="button" class="bigtime-file-delete" data-option-id="${id}" data-public-id="${f.publicId}">✕</button></div>`; });
      html += '</div>';
    }
    html += `<div class="bigtime-upload-counter"><span>Max. 5 Dateien</span><span class="bigtime-upload-count">${files.length} / 5</span></div>`;
    if (option.zeigeAnmerkung || option.zeigeanmerkung) {
      html += `<div class="bigtime-upload-comment"><label>Anmerkungen</label><textarea class="bigtime-upload-textarea" data-option-id="${id}" placeholder="${option.anmerkungPlatzhalter || 'z.B. Logo 5cm breit...'}">${appData.uploadComments[id] || ''}</textarea></div>`;
    }
    return html + '</div>';
  }

  function renderVeredelungsoptionen() {
    if (!appData.gruppe?.optionen?.length) return '';
    const totalItems = getTotalItems(), itemsList = getItemsList();
    const sorted = [...appData.gruppe.optionen].sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
    const checkedHat = sorted.filter(o => o.hatOptionen && o.typ === 'checkbox_text' && appData.checkedOptions[o.id]);

    let html = '<div class="bigtime-options"><div class="bigtime-options-title">Veredelungsoptionen</div>';
    sorted.forEach(opt => {
      const checked = appData.checkedOptions[opt.id] || false;
      html += `<div class="bigtime-option"><label class="bigtime-checkbox-label">
        <input type="checkbox" data-option-id="${opt.id}" ${checked ? 'checked' : ''}>
        <span class="bigtime-checkbox-custom"></span>
        <span>${opt.beschreibung}${opt.pflicht ? '<span class="bigtime-pflicht">*</span>' : ''}</span>
        <span class="bigtime-option-price">+${formatPriceEuro(opt.preis || 0)}</span></label>`;
      if (opt.typ === 'checkbox_text' && checked && !opt.hatOptionen) {
        html += `<div class="bigtime-textfield-container"><input type="text" class="bigtime-textfield" data-option-id="${opt.id}" data-single="true" placeholder="${opt.platzhalter || 'Text eingeben...'}" value="${appData.textFieldValues[`${opt.id}-single`] || ''}"></div>`;
      } else if (opt.typ === 'file_upload' && checked) html += renderFileUpload(opt);
      html += '</div>';
    });
    html += '</div>';

    if (checkedHat.length > 0) {
      html += '<div class="bigtime-article-fields"><div class="bigtime-article-fields-title">Individuelle Angaben pro Artikel</div>';
      if (totalItems === 0) html += '<p class="bigtime-no-items-hint">Bitte wähle zuerst Größen und Mengen.</p>';
      else {
        itemsList.forEach((item, idx) => {
          html += `<div class="bigtime-article-card"><div class="bigtime-article-card-header"><span class="article-number">${idx + 1}</span><span class="article-size">${item.size}</span></div>`;
          checkedHat.forEach(opt => {
            html += `<div class="bigtime-article-field"><div class="bigtime-article-field-label">${opt.beschreibung}</div>
              <input type="text" class="bigtime-textfield" data-option-id="${opt.id}" data-item-index="${idx}" placeholder="${opt.platzhalter || 'Text eingeben...'}" value="${appData.textFieldValues[`${opt.id}-${idx}`] || ''}"></div>`;
          });
          html += '</div>';
        });
      }
      html += '</div>';
    }
    return html;
  }

  // ============================================
  // RENDER: ZUSAMMENFASSUNG
  // ============================================
  
  function renderSummary() {
    const totalItems = getTotalItems();
    if (totalItems === 0) return '';
    const staffelpreis = appData.staffelpreiseAktiv ? getStaffelpreis(appData.staffeln, totalItems) : null;
    let productTotal = 0, veredelungTotal = 0, rows = [];

    if (appData.mode === 'single' && appData.selectedSize) {
      const v = appData.filteredVariants.find(x => getSizeFromVariant(x) === appData.selectedSize);
      if (v) {
        const ep = staffelpreis ?? parseFloat(v.price) / 100, sum = ep * appData.singleQuantity;
        productTotal = sum;
        rows.push(`<div class="bigtime-summary-row"><span>${appData.singleQuantity}x ${appData.selectedSize}${staffelpreis ? ` (je ${formatPriceEuro(ep)})` : ''}</span><span>${formatPriceEuro(sum)}</span></div>`);
      }
    } else {
      Object.entries(appData.teamQuantities).forEach(([size, qty]) => {
        if (qty > 0) {
          const v = appData.filteredVariants.find(x => getSizeFromVariant(x) === size);
          if (v) { const ep = staffelpreis ?? parseFloat(v.price) / 100, sum = ep * qty; productTotal += sum; rows.push(`<div class="bigtime-summary-row"><span>${qty}x ${size}</span><span>${formatPriceEuro(sum)}</span></div>`); }
        }
      });
    }
    appData.gruppe?.optionen?.forEach(opt => {
      if (appData.checkedOptions[opt.id]) { const sum = (opt.preis || 0) * totalItems; veredelungTotal += sum; rows.push(`<div class="bigtime-summary-row"><span>${opt.beschreibung} (${totalItems}x)</span><span>${formatPriceEuro(sum)}</span></div>`); }
    });
    return `<div class="bigtime-summary"><div class="bigtime-summary-title">Zusammenfassung</div>${rows.join('')}<div class="bigtime-summary-row bigtime-summary-total"><span>Gesamt</span><span>${formatPriceEuro(productTotal + veredelungTotal)}</span></div></div>`;
  }

  // ============================================
  // VALIDIERUNG & WARENKORB
  // ============================================
  
  function validateBeforeCart() {
    const errors = [], totalItems = getTotalItems();
    if (totalItems === 0) { errors.push('Bitte wähle mindestens eine Größe und Menge.'); return errors; }
    appData.gruppe?.optionen?.forEach(opt => {
      if (opt.pflicht && !appData.checkedOptions[opt.id]) errors.push(`"${opt.beschreibung}" ist Pflicht.`);
      if (appData.checkedOptions[opt.id]) {
        if (opt.typ === 'checkbox_text') {
          if (opt.hatOptionen) { if (getItemsList().some((_, i) => !appData.textFieldValues[`${opt.id}-${i}`]?.trim())) errors.push(`"${opt.beschreibung}": Alle Felder ausfüllen.`); }
          else if (!appData.textFieldValues[`${opt.id}-single`]?.trim()) errors.push(`"${opt.beschreibung}": Text eingeben.`);
        }
        if (opt.typ === 'file_upload' && !appData.uploadedFiles[opt.id]?.length) errors.push(`"${opt.beschreibung}": Datei hochladen.`);
      }
    });
    return errors;
  }

  /**
   * Prüft ob eine Veredelungsoption individuelle Texte PRO ARTIKEL hat
   */
  function hasPerItemTexts() {
    if (!appData.gruppe?.optionen) return false;
    return appData.gruppe.optionen.some(opt => 
      opt.hatOptionen && opt.typ === 'checkbox_text' && appData.checkedOptions[opt.id]
    );
  }

  /**
   * v3.9.9: Erstellt die Base-Properties - strukturiert in Gruppen mit Trennern (Thomas-Auftrag 29.09.2026)
   * Reihenfolge: — ALLGEMEIN — -> — VEREDELUNGSOPTIONEN — -> — DATEIEN — -> _— TECHNISCH (INTERN) — -> _— DRUCKDATEI-REFERENZ —
   * Trenner mit "_" Prefix sind kundenunsichtbar (Shopify blendet "_"-Properties im Frontend/Checkout aus),
   * Trenner ohne "_" sind kundensichtbar im Shopify Admin/Bestell-Properties.
   * Eine Trenner-Zeile wird nur gesetzt wenn die zugehoerige Gruppe mindestens einen Wert hat.
   * @param {Object} variant - Die Shopify-Variante
   * @param {Array} files - Hochgeladene Dateien
   * @param {string} folderPath - Ordnerpfad für Druckdateien
   * @param {string|null} encryptedVariantId - Die verschlüsselte Varianten-ID (nur bei Staffelpreisen)
   * @param {number|null} itemIndex - Item-Index bei individuellen Texten pro Artikel (Modus 1, siehe addToCart). Sonst null.
   */
  function buildBaseProperties(variant, files, folderPath, encryptedVariantId, itemIndex = null) {
    const props = {};

    // — ALLGEMEIN — (kundensichtbar)
    const allgemein = {};
    if (appData.gruppe?.name) {
      allgemein['Veredelungsgruppe'] = appData.gruppe.name;
    }
    if (appData.selectedColor && appData.hasColors && appData.selectedColor !== 'Default Title') {
      allgemein['Farbe'] = appData.selectedColor;
    }
    if (Object.keys(allgemein).length > 0) {
      props['— ALLGEMEIN —'] = '';
      Object.assign(props, allgemein);
    }

    // — VEREDELUNGSOPTIONEN — (kundensichtbar, Property-Name mit Prefix "Veredelung ")
    const veredelungsoptionen = {};
    appData.gruppe?.optionen?.forEach(opt => {
      if (!appData.checkedOptions[opt.id]) return;
      if (opt.typ === 'checkbox') {
        veredelungsoptionen[`Veredelung ${opt.beschreibung}`] = 'Ja';
      } else if (opt.typ === 'checkbox_text' && !opt.hatOptionen) {
        // Gleicher Text für alle Items
        const text = appData.textFieldValues[`${opt.id}-single`] || '';
        if (text) veredelungsoptionen[`Veredelung ${opt.beschreibung}`] = text;
      } else if (opt.typ === 'checkbox_text' && opt.hatOptionen && itemIndex !== null) {
        // Individueller Text pro Artikel (Modus 1 in addToCart) - v3.9.9: jetzt konsistent
        // mit gleichem Prefix + in dieser Gruppe statt nachtraeglich angehaengt
        const text = appData.textFieldValues[`${opt.id}-${itemIndex}`] || '';
        if (text) veredelungsoptionen[`Veredelung ${opt.beschreibung}`] = text;
      }
    });
    if (Object.keys(veredelungsoptionen).length > 0) {
      props['— VEREDELUNGSOPTIONEN —'] = '';
      Object.assign(props, veredelungsoptionen);
    }

    // — DATEIEN — (kundensichtbar, bei ALLEN Items gleich!)
    if (files.length > 0) {
      const fileNames = files.map(f => f.fileName).join(', ');
      const dateien = {};
      appData.gruppe?.optionen?.forEach(opt => {
        if (opt.typ === 'file_upload' && appData.checkedOptions[opt.id]) {
          dateien[opt.beschreibung] = fileNames;
          const comment = appData.uploadComments?.[opt.id];
          if (comment?.trim()) {
            dateien[`${opt.beschreibung} - Anmerkung`] = comment.trim();
          }
        }
      });
      if (Object.keys(dateien).length > 0) {
        props['— DATEIEN —'] = '';
        Object.assign(props, dateien);
      }
    }

    // _— TECHNISCH (INTERN) — (kundenunsichtbar)
    if (appData.staffelpreiseAktiv && window.bigtimeStaffelpreise?.staffeln) {
      props['_— TECHNISCH (INTERN) —'] = '';
      props['_staffelpreise'] = window.bigtimeStaffelpreise.staffeln;
      // NEU (v3.9.4): _enc statt _staffelpreis_originalpreis
      if (encryptedVariantId) {
        props['_enc'] = encryptedVariantId;
      }
    }

    // _— DRUCKDATEI-REFERENZ — (kundenunsichtbar)
    if (files.length > 0) {
      props['_— DRUCKDATEI-REFERENZ —'] = '';
      props['_Druckdateien-Ordner'] = folderPath;
      props['_Druckdateien'] = files.map(f => f.url).join(' | ');
    }

    return props;
  }

  /**
   * v3.9.4: addToCart Funktion - mit Varianten-ID Verschlüsselung
   */
  async function addToCart() {
    const errors = validateBeforeCart();
    if (errors.length > 0) return { success: false, errors };
    
    const items = [];
    const itemsList = getItemsList();
    const files = getAllUploadedFiles();
    const folderPath = `bigtime-druckdateien/${appData.sessionId}/${appData.productHandle}`;
    
    // Prüfe ob wir individuelle Texte pro Artikel haben
    const perItemTexts = hasPerItemTexts();
    
    // v3.9.4 NEU: Verschlüsselte Varianten-IDs vorab holen (nur wenn Staffelpreise aktiv)
    const encryptionCache = {};
    
    if (appData.staffelpreiseAktiv) {
      console.log('🔐 Bigtime: Verschlüssele Varianten-IDs...');
      
      // Sammle alle unique Varianten-IDs
      const uniqueVariantIds = new Set();
      itemsList.forEach(item => {
        const variant = appData.filteredVariants.find(x => getSizeFromVariant(x) === item.size);
        if (variant) uniqueVariantIds.add(variant.id);
      });
      
      // Verschlüssele alle parallel
      const encryptPromises = Array.from(uniqueVariantIds).map(async (variantId) => {
        const enc = await encryptVariantId(variantId);
        return [variantId, enc];
      });
      
      const encryptResults = await Promise.all(encryptPromises);
      encryptResults.forEach(([variantId, enc]) => {
        if (enc) encryptionCache[variantId] = enc;
      });
      
      console.log('✅ Bigtime:', Object.keys(encryptionCache).length, 'Varianten verschlüsselt');
    }
    
    if (perItemTexts) {
      // MODUS 1: Individuelle Texte pro Artikel → Jedes Item einzeln (quantity: 1)
      console.log('🛒 Bigtime: Individuelle Texte - einzelne Items');
      
      itemsList.forEach((item, idx) => {
        const variant = appData.filteredVariants.find(x => getSizeFromVariant(x) === item.size);
        if (!variant) return;
        
        // v3.9.4: Verschlüsselte ID aus Cache holen
        const encryptedId = encryptionCache[variant.id] || null;
        // v3.9.9: idx uebergeben, damit individuelle Texte konsistent als "Veredelung [Name]"
        // in der VEREDELUNGSOPTIONEN-Gruppe landen (statt nachtraeglich angehaengt)
        const props = buildBaseProperties(variant, files, folderPath, encryptedId, idx);

        items.push({ id: variant.id, quantity: 1, properties: props });
      });
      
    } else {
      // MODUS 2: Keine individuellen Texte → Identische Varianten zusammenfassen
      console.log('🛒 Bigtime: Keine individuellen Texte - Items zusammenfassen');
      
      const variantQuantities = {};
      
      itemsList.forEach(item => {
        const variant = appData.filteredVariants.find(x => getSizeFromVariant(x) === item.size);
        if (!variant) return;
        
        if (!variantQuantities[variant.id]) {
          variantQuantities[variant.id] = { variant, quantity: 0 };
        }
        variantQuantities[variant.id].quantity++;
      });
      
      // Erstelle ein Item pro Variante mit der summierten Menge
      Object.values(variantQuantities).forEach(({ variant, quantity }) => {
        // v3.9.4: Verschlüsselte ID aus Cache holen
        const encryptedId = encryptionCache[variant.id] || null;
        const props = buildBaseProperties(variant, files, folderPath, encryptedId);
        items.push({ id: variant.id, quantity, properties: props });
      });
    }
    
    // Veredelungs-Produkte hinzufügen (falls konfiguriert)
    const totalQuantity = itemsList.length;
    appData.gruppe?.optionen?.forEach(opt => {
      if (appData.checkedOptions[opt.id] && opt.shopifyVariantId) {
        items.push({
          id: parseInt(opt.shopifyVariantId),
          quantity: totalQuantity,
          properties: { 'Veredelung für': opt.beschreibung }
        });
      }
    });
    
    console.log('🛒 Bigtime Cart Items:', items);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Fehler beim Hinzufügen');
      }
      
      return { success: true };
    } catch (e) {
      console.error('Cart error:', e);
      return { success: false, errors: ['Fehler beim Hinzufügen. Bitte erneut versuchen.'] };
    }
  }

  // ============================================
  // EVENT LISTENERS
  // ============================================
  
  function bindEventListeners(container) {
    container.querySelectorAll('.bigtime-tab').forEach(t => t.addEventListener('click', () => { appData.mode = t.dataset.mode; appData.selectedSize = null; appData.singleQuantity = 1; const lzBox = document.querySelector('[data-bt-lz]'); if (lzBox) lzBox.hidden = (appData.mode === 'team'); renderApp(); }));
    container.querySelectorAll('.bigtime-size-tile:not([data-disabled])').forEach(t => t.addEventListener('click', () => { appData.selectedSize = t.dataset.size; appData.singleQuantity = 1; renderApp(); }));
    
    const qtyInput = container.querySelector('.bigtime-qty-input');
    if (qtyInput) {
      qtyInput.addEventListener('change', e => { let v = parseInt(e.target.value) || 1; appData.singleQuantity = Math.max(1, Math.min(999, v)); renderApp(); });
      qtyInput.addEventListener('input', e => { e.target.value = e.target.value.replace(/[^0-9]/g, ''); });
    }
    container.querySelectorAll('.bigtime-quantity-control .bigtime-qty-btn').forEach(b => b.addEventListener('click', () => { if (b.dataset.action === 'increase') appData.singleQuantity++; else if (appData.singleQuantity > 1) appData.singleQuantity--; renderApp(); }));
    container.querySelectorAll('.bigtime-size-table .qty-btn').forEach(b => b.addEventListener('click', () => { const s = b.dataset.size, c = appData.teamQuantities[s] || 0; if (b.dataset.action === 'increase') appData.teamQuantities[s] = c + 1; else if (c > 0) appData.teamQuantities[s] = c - 1; renderApp(); }));
    container.querySelectorAll('.bigtime-size-table .qty-input').forEach(i => { i.addEventListener('change', e => { appData.teamQuantities[e.target.dataset.size] = Math.max(0, Math.min(999, parseInt(e.target.value) || 0)); renderApp(); }); i.addEventListener('input', e => { e.target.value = e.target.value.replace(/[^0-9]/g, ''); }); });
    container.querySelectorAll('.bigtime-options input[type="checkbox"]').forEach(c => c.addEventListener('change', e => { appData.checkedOptions[parseInt(e.target.dataset.optionId)] = e.target.checked; renderApp(); }));
    container.querySelectorAll('.bigtime-textfield').forEach(t => t.addEventListener('input', e => { const k = e.target.dataset.single ? `${e.target.dataset.optionId}-single` : `${e.target.dataset.optionId}-${e.target.dataset.itemIndex}`; appData.textFieldValues[k] = e.target.value; }));
    container.querySelectorAll('.bigtime-file-input').forEach(i => i.addEventListener('change', e => { handleFileSelectWithValidation(e.target.files, parseInt(e.target.dataset.optionId)); e.target.value = ''; }));
    container.querySelectorAll('.bigtime-drop-zone').forEach(z => { const id = parseInt(z.dataset.optionId); z.addEventListener('dragover', e => { e.preventDefault(); z.classList.add('dragover'); }); z.addEventListener('dragleave', () => z.classList.remove('dragover')); z.addEventListener('drop', e => { e.preventDefault(); z.classList.remove('dragover'); if (e.dataTransfer.files.length) handleFileSelectWithValidation(e.dataTransfer.files, id); }); });
    container.querySelectorAll('.bigtime-formats-toggle').forEach(b => b.addEventListener('click', e => { e.preventDefault(); const i = document.getElementById(`formats-info-${b.dataset.optionId}`); if (i) i.style.display = i.style.display === 'none' ? 'block' : 'none'; }));
    container.querySelectorAll('.bigtime-file-delete').forEach(b => b.addEventListener('click', e => { e.preventDefault(); if (confirm('Datei löschen?')) deleteFile(b.dataset.publicId, parseInt(b.dataset.optionId)).catch(err => alert(err.message)); }));
    container.querySelectorAll('.bigtime-upload-textarea').forEach(t => t.addEventListener('input', e => { if (!appData.uploadComments) appData.uploadComments = {}; appData.uploadComments[parseInt(e.target.dataset.optionId)] = e.target.value; }));
    
    const addBtn = container.querySelector('.bigtime-add-to-cart');
    if (addBtn) addBtn.addEventListener('click', async () => {
      addBtn.classList.add('loading'); addBtn.disabled = true;
      const result = await addToCart();
      if (result.success) {
        // v3.9.8: Theme-Warenkorbstil "Seite" (bzw. wir sind schon auf /cart) -> wie bisher zur Cart-Seite.
        // Sonst: Theme-eigenen Refresh+Open-Hook nutzen (cart-drawer.js hoert auf 'cart:refresh',
        // laedt den Mini-Cart-Sectioninhalt frisch und oeffnet danach den Einschub).
        const isPageCart = (typeof theme !== 'undefined' && theme.settings && theme.settings.cartType === 'page') ||
          document.body.classList.contains('template-cart') || window.location.pathname === '/cart';
        if (isPageCart) {
          window.location.href = '/cart';
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
          addBtn.classList.remove('loading'); addBtn.disabled = false;
        }
      }
      else { const err = container.querySelector('#bigtime-error-container'); if (err) err.innerHTML = `<div class="bigtime-error">${result.errors.join('<br>')}</div>`; addBtn.classList.remove('loading'); addBtn.disabled = false; }
    });
  }

  // ============================================
  // HAUPT-RENDER-FUNKTION
  // ============================================
  
  function renderApp() {
    const container = document.getElementById('bigtime-veredelung-container');
    if (!container) return;
    
    hideThemeAddToCart();
    if (appData.gruppe) hideThemeSizeSelector();
    
    // NEU: Loading-State während Varianten geladen werden
    if (appData.variantsLoading) {
      container.innerHTML = `<div class="bigtime-wrapper">${renderLoadingState()}</div>`;
      return;
    }
    
    // v3.9.5: UVP vor Render aktualisieren (dynamisch bei Größenwechsel)
    updateUvpForCurrentSelection();
    
    const variants = appData.filteredVariants.length > 0 ? appData.filteredVariants : appData.variants;
    
    if (appData.hasColors && !appData.selectedColor) {
      container.innerHTML = `<div class="bigtime-wrapper"><div class="bigtime-color-hint"><span>👆</span><span>Bitte wähle zuerst oben eine <strong>Farbe</strong> aus.</span></div></div>`;
      return;
    }
    // v3.9.6 NEU: Zwischenschritt Geschlecht - nur wenn das Produkt die Option hat
    if (appData.hasGender && !appData.selectedGender) {
      container.innerHTML = `<div class="bigtime-wrapper"><div class="bigtime-color-hint"><span>👆</span><span>Bitte wähle zusätzlich oben ein <strong>Geschlecht</strong> aus.</span></div></div>`;
      return;
    }
    if (variants.length === 0) {
      const hinweisText = appData.hasGender
        ? 'Keine Größen für diese Farbe/Geschlecht-Kombination verfügbar. Bitte wähle eine andere Farbe oder ein anderes Geschlecht.'
        : 'Keine Größen für diese Farbe verfügbar. Bitte wähle eine andere Farbe.';
      container.innerHTML = `<div class="bigtime-wrapper"><div class="bigtime-color-hint"><span>⚠️</span><span>${hinweisText}</span></div></div>`;
      return;
    }
    
    const isDefault = variants.length === 1 && (getSizeFromVariant(variants[0]) === 'Default Title' || variants[0].title === 'Default Title' || !variants[0].option1 || variants[0].option1 === 'Default Title');
    if (isDefault && !appData.selectedSize) appData.selectedSize = getSizeFromVariant(variants[0]);
    
    const currentQty = getTotalItems() || 1;
    let html = '<div class="bigtime-wrapper">';
    
    // Modul 3: Staffelpreise
    html += renderStaffelpreisTabelle(currentQty);
    
    // Modul 1: Hauptmodul
    html += renderFarbInfo();
    html += renderGenderInfo();
    if (isDefault) {
      html += renderMengenInput(appData.singleQuantity);
    } else {
      html += renderModusTabs();
      html += '<div class="bigtime-sizes">';
      if (appData.mode === 'single') { html += renderGroessenTiles(variants); if (appData.selectedSize) html += renderMengenInput(appData.singleQuantity); }
      else html += renderGroessenTabelle(variants);
      html += '</div>';
    }
    
    // Modul 2: Veredelung
    html += renderVeredelungsoptionen();
    
    // Zusammenfassung & Button
    html += renderSummary();
    html += '<div id="bigtime-error-container"></div>';
    html += '<button class="bigtime-add-to-cart">In den Einkaufswagen legen</button>';
    html += '</div>';
    
    container.innerHTML = html;
    injectStyles();
    bindEventListeners(container);
  }

  // ============================================
  // INITIALISIERUNG
  // ============================================
  
  window.initBigtimeApp = function(gruppe, productHandle) {
    console.log('🚀 Bigtime App v3.9.6 - Geschlecht als dritte Auswahl-Dimension');
    
    appData.gruppe = gruppe;
    appData.variants = window.bigtimeProductVariants || [];
    appData.productHandle = productHandle || 'unknown';
    appData.uploadedFiles = {};
    appData.sessionId = getOrCreateSessionId();
    appData.mode = 'single';
    appData.selectedSize = null;
    appData.singleQuantity = 1;
    appData.teamQuantities = {};
    appData.checkedOptions = {};
    appData.textFieldValues = {};
    appData.uploadComments = {};
    appData.variantsLoading = false;
    appData.variantsCache = {}; // Cache zurücksetzen
    appData.sectionId = getSectionId();
    
    if (window.bigtimeStaffelpreise) {
      appData.staffelpreiseAktiv = window.bigtimeStaffelpreise.aktiv || false;
      appData.staffeln = parseStaffelpreise(window.bigtimeStaffelpreise.staffeln);
      appData.einheit = window.bigtimeStaffelpreise.einheit || 'Stück';
      appData.uvp = window.bigtimeStaffelpreise.uvp || null;
      appData.hatGrundpreis = window.bigtimeStaffelpreise.hatGrundpreis || false;
      appData.quantityValue = window.bigtimeStaffelpreise.quantityValue || 1;
      appData.referenceValue = window.bigtimeStaffelpreise.referenceValue || 1;
    }
    
    gruppe?.optionen?.forEach(opt => { if (opt.vorausgewaehlt) appData.checkedOptions[opt.id] = true; });
    
    injectSizeHidingCSS();
    hideThemeAddToCart();
    analyzeProductOptions(appData.variants);
    appData.selectedColor = getCurrentColorFromTheme();
    appData.selectedGender = getCurrentGenderFromTheme();
    const needsSelection = (appData.hasColors && !appData.selectedColor) || (appData.hasGender && !appData.selectedGender);
    appData.filteredVariants = needsSelection
      ? appData.variants
      : filterVariantsByColor(appData.variants, appData.selectedColor, appData.selectedGender);

    console.log('🔧 Bigtime Config:', {
      hasGruppe: !!gruppe,
      staffelpreise: appData.staffelpreiseAktiv,
      variants: appData.variants.length,
      filteredVariants: appData.filteredVariants.length,
      colors: appData.availableColors.length,
      selectedColor: appData.selectedColor,
      hasGender: appData.hasGender,
      genders: appData.availableGenders.length,
      selectedGender: appData.selectedGender,
      sectionId: appData.sectionId
    });
    
    injectStyles();
    renderApp();
    setupSizeHidingObserver();
    watchColorChanges();
    
    // v3.9.3: Robuster Browser-Navigation Handler
    // Prüft bei JEDER pageshow ob State noch stimmt
    // v3.9.6: Prüft zusätzlich das Geschlecht (sofern appData.hasGender)
    window.addEventListener('pageshow', async (event) => {
      // Kleine Verzögerung um DOM-Updates abzuwarten
      await new Promise(r => setTimeout(r, 50));

      const currentThemeColor = getCurrentColorFromTheme();
      const currentThemeGender = getCurrentGenderFromTheme();
      console.log('🔄 Bigtime: pageshow - Theme Farbe:', currentThemeColor, '| App Farbe:', appData.selectedColor, '| Theme Geschlecht:', currentThemeGender, '| App Geschlecht:', appData.selectedGender);

      const colorChanged = currentThemeColor && currentThemeColor !== appData.selectedColor;
      const genderChanged = appData.hasGender && currentThemeGender && currentThemeGender !== appData.selectedGender;

      // Fall 1: Farbe und/oder Geschlecht hat sich geändert
      if (colorChanged || genderChanged) {
        console.log('🎨 Bigtime: Auswahl synchronisieren - Farbe:', appData.selectedColor, '→', currentThemeColor, '| Geschlecht:', appData.selectedGender, '→', currentThemeGender);

        appData.selectedColor = currentThemeColor || appData.selectedColor;
        appData.selectedGender = appData.hasGender ? (currentThemeGender || appData.selectedGender) : null;
        appData.selectedSize = null;
        appData.teamQuantities = {};
        appData.variantsLoading = true;
        renderApp();

        const newVariants = await loadVariantsForColor(appData.selectedColor, appData.selectedGender);
        appData.filteredVariants = newVariants.length > 0 ? newVariants : filterVariantsByColor(appData.variants, appData.selectedColor, appData.selectedGender);
        appData.variantsLoading = false;

        renderApp();
      }
      // Fall 2: Gleiche Auswahl aber keine Varianten geladen (z.B. nach Browser-Cache)
      else if (appData.hasColors && appData.selectedColor && appData.filteredVariants.length === 0) {
        console.log('🔄 Bigtime: Varianten neu laden für:', appData.selectedColor, appData.selectedGender);
        appData.variantsLoading = true;
        renderApp();

        const newVariants = await loadVariantsForColor(appData.selectedColor, appData.selectedGender);
        appData.filteredVariants = newVariants.length > 0 ? newVariants : filterVariantsByColor(appData.variants, appData.selectedColor, appData.selectedGender);
        appData.variantsLoading = false;

        renderApp();
      }
    });
  };

})();
